import { EventEmitter, Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { Observable } from 'rxjs';
import { UigUserRolesService } from './uig-user-roles.service';

@Injectable({
    providedIn: 'root'
})
export class UigShopViewService {

    private sessionStorage: Storage;
    SHOP_VIEW_USER = "shopview_user";
    shopViewActivated: boolean;
    hasShopViewUserRole: boolean = false;
    shopViewToggleEvent = new EventEmitter<Boolean>(false);

    constructor(
        winRef: WindowRef,
        private uigUserRolesService: UigUserRolesService
    ) {
        this.sessionStorage = winRef.sessionStorage;
        this.setShopView();
        this.uigUserRolesService.hasRoleOrAuthority(this.SHOP_VIEW_USER).subscribe((hasRole) => {
            this.hasShopViewUserRole = hasRole;
        });
    }

    toggleShopView() {
        if (!this.hasShopViewUserRole) {
            this.shopViewActivated = !this.shopViewActivated;
            this.shopViewToggleEvent.emit(this.shopViewActivated);
            this.sessionStorage.setItem("shopView", (this.shopViewActivated).toString());
            window.location.reload();
        }
    }

    reset() {
        this.shopViewToggleEvent.emit(false);
        this.shopViewActivated = false;
        this.sessionStorage.setItem("shopView","false");
    }

    setShopView(){
        if(this.sessionStorage.getItem("shopView") == null)
        {
            this.sessionStorage.setItem("shopView","false");
            this.shopViewActivated = false;
        } else {
            this.shopViewActivated = (this.sessionStorage.getItem("shopView") === "true");
        }
    }

    isShopViewMode(): Observable<boolean> {
        return this.uigUserRolesService.hasRoleOrAuthority(this.SHOP_VIEW_USER,'ROLE_SHOPVIEW');
    }
}
